import PropTypes from 'prop-types'
import React from 'react'
import { CopyButton } from 'components/common/clipboard/CopyButton'

const CopyUrlPropTypes = {
  url: PropTypes.string.isRequired
}

type CopyUrlProps = PropTypes.InferProps<typeof CopyUrlPropTypes>

export const CopyUrl: React.FC<CopyUrlProps> = ({ url }) => {
  return (
    <CopyButton buttonLabel='COPY URL' copyText={url} className='url-action' />
  )
}
